module.exports = __webpack_public_path__ + "img/ic_qrcode_tiktok.b3e055a.png";